import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const values = [
  {
    num: '01',
    title: '命を大切にする',
    text: 'すべての命のかけがえのない尊さを、Hugは大切にしています。',
    icon: 'ri-heart-line',
    color: '#C97B7B',
  },
  {
    num: '02',
    title: '人とのつながり',
    text: '人と人とのつながりを大切にし、温かい社会を目指します。',
    icon: 'ri-links-line',
    color: '#A8835A',
  },
  {
    num: '03',
    title: 'やさしさ',
    text: '誰かの気持ちに寄り添い、そっと支えることを大切にしています。',
    icon: 'ri-emotion-line',
    color: '#C97B7B',
  },
  {
    num: '04',
    title: '誠実であること',
    text: '家族の想いに対して、誠実に向き合い続けます。',
    icon: 'ri-shield-star-line',
    color: '#A8835A',
  },
  {
    num: '05',
    title: '未来への責任',
    text: '次の世代へより良い未来をつないでいきます。',
    icon: 'ri-leaf-line',
    color: '#C97B7B',
  },
];

export default function ValuesSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const refs = [
    useScrollAnimation(0.08),
    useScrollAnimation(0.08),
    useScrollAnimation(0.08),
    useScrollAnimation(0.08),
    useScrollAnimation(0.08),
  ];

  return (
    <section id="values" className="py-28 px-6" style={{ backgroundColor: '#221A14' }}>
      <div className="max-w-5xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <p className="text-[#E8C4C4]/60 text-xs tracking-[0.5em] mb-4 uppercase">Our Values</p>
          <h2
            className="text-white text-3xl md:text-4xl font-light mb-4"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            大切にしていること
          </h2>
          <div className="w-10 h-px bg-[#C8B99A]/40 mx-auto mb-5" />
          <p className="text-white/35 text-xs tracking-[0.3em]">
            Hugが大切にする5つの価値観
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}>
          {values.map((v, i) => {
            const { ref, isVisible } = refs[i];
            return (
              <div
                key={v.num}
                ref={ref}
                className={`relative flex flex-col items-center text-center px-10 py-12 fade-in ${isVisible ? 'visible' : ''}`}
                style={{ backgroundColor: '#221A14' }}
              >
                {/* 薄い大きな数字 */}
                <span
                  className="absolute top-5 right-7 text-6xl font-light leading-none select-none pointer-events-none"
                  style={{
                    color: v.color,
                    opacity: 0.1,
                    fontFamily: 'Georgia, serif',
                  }}
                >
                  {v.num}
                </span>

                {/* アイコン */}
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-full mb-6"
                  style={{ backgroundColor: `${v.color}18` }}
                >
                  <i className={`${v.icon} text-xl`} style={{ color: v.color }} />
                </div>

                <h3
                  className="text-white text-sm font-medium mb-3 leading-snug"
                  style={{ fontFamily: 'Noto Serif JP, serif' }}
                >
                  {v.title}
                </h3>

                <p className="text-white/40 text-xs leading-relaxed">{v.text}</p>

                {/* 下部ライン */}
                <div
                  className="absolute bottom-0 left-1/2 -translate-x-1/2 h-px w-12"
                  style={{ backgroundColor: `${v.color}35` }}
                />
              </div>
            );
          })}

          {/* 3列グリッドの余白埋め */}
          <div className="hidden md:block" style={{ backgroundColor: '#221A14' }} />
        </div>
      </div>
    </section>
  );
}
